<template>
  <div class="login">
    <div class="login-logo">
      <a href="/">
        <img :src="logo" class="logo" alt="logo" />
      </a>
    </div>

    <div class="login-content" :class="loginWay === 'password' ? 'login-curr' : 'login-next'">
      <div class="login-title">{{$t('base.accountLogin')}}</div>
      <a-form class="login-form" ref="formLogin" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            type="text"
            placeholder="账号"
            autocomplete
            v-decorator="[
              'username',
              {
                rules: [{ required: true, message: '请输入帐户名' }, { validator: handleUsernameOrEmail }],
                validateTrigger: 'change',
              },
            ]"
          >
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-input-password
            size="large"
            placeholder="密码"
            v-decorator="[
              'password',
              { rules: [{ required: true, message: '请输入密码！' }], validateTrigger: 'blur' },
            ]"
            autocomplete
          >
          </a-input-password>
        </a-form-item>

        <a-form-item style="margin-top: 30px; margin-bottom: 16px">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="state.loginBtn"
            :disabled="state.loginBtn"
          >
            {{$t('base.login')}}
          </a-button>
          <a-button size="large" type="" class="forget-button" @click="forgetPwd()"> {{$t('base.forgetPassword')}}?</a-button>
          <a-button size="large" type="" class="reg-button" @click="register()"> {{$t('base.register')}} </a-button>

        </a-form-item>

        <div class="other-login flex start-center">
          <span>{{$t('base.thirdPartyLogin')}}:</span>
          <div class="other-login-item flex center-center cursor-pointer not-select" @click="loginSwitcher('qywx')">
            <svg-icon class-name="logo" icon-class="qywx" />
          </div>
          <div class="other-login-item flex center-center cursor-pointer not-select" @click="loginSwitcher('wx')">
            <svg-icon class-name="logo" icon-class="wechat" />
          </div>
          <div class="other-login-item flex center-center cursor-pointer not-select" @click="loginSwitcher('cc')">
            <svg-icon class-name="logo" icon-class="cc_logo_w" />
          </div>
        </div>
      </a-form>
    </div>
    <div class="login-content wx-content" :class="loginWay === 'qywx' ? 'login-curr' : 'login-next'">
      <div class="login-switch cursor-pointer" @click="loginSwitcher('password')">
        <svg-icon class-name="account-login" icon-class="account-login"></svg-icon>
      </div>
      <div id="wx_box"></div>
    </div>
    <a-modal
      v-model="visible"
      title="滑动验证"
      :footer="null"
      :centered="true"
      width="348px"
      :maskClosable="false"
      @cancel="handleCancelJigsaw"
    >
      <Jigsaw
        ref="dialogopen"
        :imgurl="imgurl"
        :miniimgurl="miniimgurl"
        :blocky="blocky"
        @success="onSuccess"
        @refresh="onRefresh"
      />
    </a-modal>
  </div>
</template>

<script>
import { timeFix } from '@/utils/util'
import { getCurrentUser } from '@/utils/auth'
import config from '@/config/defaultSettings'
import Jigsaw from '../components/jigsaw.vue'
import { getJigsawInfo } from '../../../api/user'
import aes from '@/utils/aes'
export default {
  components: {
    Jigsaw,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        loginType: 0,
        smsSendBtn: false,
      },
      loginWay: 'password', // password: 账号密码   wx: 企业微信
      logo: config.loginLogo,
      visible: false,
      imgurl: '', //滑动大图
      miniimgurl: '', //滑动小图
      blocky: '', //小图初始的垂直距离
      blockx: 0, //小图滑动距离
      loginFlg: 0, //登录状态
    }
  },
  created() {
    this.getJigsaw()
    this.loginFlg = localStorage.getItem('loginFlg')
  },
  methods: {
    // 获取滑动拼图信息
    getJigsaw() {
      getJigsawInfo().then((res) => {
        if (res.status == 0) {
          this.imgurl = res.data.backFile
          this.miniimgurl = res.data.markFile
          this.blocky = res.data.ylocation
          this.blockx = res.data.xlocation
          this.$nextTick(() => {
            if (this.$refs.dialogopen) {
              this.$refs.dialogopen.reset(res.data.ylocation)
            }
          })
        }
      })
    },
    // 刷新
    onRefresh() {
      this.imgurl = ''
      this.miniimgurl = ''
      this.getJigsaw()
    },
    onSuccess(left) {
      const maxX = this.blockx + 5
      const minX = this.blockx - 5
      console.log(maxX, minX)
      if (left <= maxX && left >= minX) {
        this.$refs.dialogopen.handleSuccess()
        setTimeout(() => {
          this.visible = false
        }, 500)
        this.state.loginBtn = false
        this.loginFlg = 0
      } else {
        this.$refs.dialogopen.handleFail()
        this.visible = true
        setTimeout(() => {
          this.getJigsaw()
        }, 500)
      }
    },
    handleCancelJigsaw() {
      this.visible = false
      this.state.loginBtn = false
    },
    // 注册
    register() {
      this.$router.push('/register')
    },
    // 忘记密码
    forgetPwd() {
      this.$router.push('/forgetPwd')
    },

    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
      } = this
      state.loginBtn = true

      const validateFieldsKey = ['username', 'password']
      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          if (this.loginFlg == 1) {
            this.visible = true
            state.loginBtn = true
          } else {
            const loginParams = {
              username: values.username,
              password: aes.encrypt(values.password),
            }
            this.$store
              .dispatch('user/login', loginParams)
              .then(() => {
                this.loginFlg = 0
                localStorage.setItem('loginFlg', 0)
                this.loginSuccess()
                state.loginBtn = false
              })
              .catch((error) => {
                console.log('error: ', error)
                if (error.data == 1) {
                  this.loginFlg = error.data
                  localStorage.setItem('loginFlg', error.data)
                  this.visible = true
                  state.loginBtn = true
                } else {
                  state.loginBtn = false
                  this.$message.error(error.message)
                }
              })
          }
        } else {
          state.loginBtn = false
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // {path: '/user/login', query: { redirect: this.$router.currentRoute.fullPath }
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          top: '100px',
          message: '欢迎',
          description: `${getCurrentUser()}! ${timeFix()}，欢迎回来`,
        })
      }, 1000)
    },
    // 企业微信二维码
    initWxLogin() {
      window.WwLogin({
        id: 'wx_box',
        appid: 'wwcbd09cea76e76e7d',
        agentid: '1000007', // 生产环境
        redirect_uri: 'http://fr.zjbcpro.com/user/login', // 生产环境
        // agentid: '1000005', // 测试环境
        // redirect_uri: `http://4080723ig2.oicp.vip/user/login`, // 测试环境
        state: 'STATE',
        // href: '',
      })
    },
    loginSwitcher(type) {
      if (type === 'qywx') {
        this.loginWay = type
        this.initWxLogin()
      } else if (type === 'cc' || type === 'wx') {
        this.$message.warning('该登录方式正在紧急开发中...')
      } else {
        this.loginWay = type
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    const query = to.query

    next((vm) => {
      if (query.code) {

        vm.$store
          .dispatch('user/wxLogin', query.code)
          .then((res) => {
            setTimeout(() => {
              vm.loginSuccess()
            }, 2000)
          })
          .catch((error) => {})
      }
    })
  },
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  height: 100%;
  background: url('~@/assets/bg/login-bg.png') no-repeat center;
  background-size: cover;
  .login-logo {
    position: absolute;
    top: 37px;
    left: 46px;
    .logo {
      width: auto;
      height: 64px;
    }
  }

  .login-content {
    position: absolute;
    top: 25%;
    left: 180px;
    width: 457px;
    height: 440px;
    transition: all 0.3s;
    transform: translateX(0);
    .login-title {
      margin-bottom: 25px;
      font-size: 36px;
      font-weight: bold;
      color: #fff;
    }
    .login-form {
      /deep/.ant-form-item {
        margin-bottom: 45px;
        .ant-form-item-control {
          width: 457px;
          .ant-input {
            height: 70px;
            font-size: 26px;
            color: #fff;
            background-color: transparent;
            border: 2px solid #fff;
            opacity: 1;
            border-radius: 10px;
            &:-internal-autofill-previewed,
            &:-internal-autofill-selected {
              -webkit-text-fill-color: #ffffff !important;
              transition: background-color 5000s ease-in-out 0s !important;
            }
          }
        }
      }
    }
    .login-button {
      margin-top: 14px;
      width: 164px;
      height: 60px;
      background-color: #3a5dea;
      border-color: #3a5dea;
      border-radius: 30px;
      font-size: 24px;
      margin-right: 15px;
    }
    .forget-button,
    .reg-button {
      border: none;
      background-color: rgba(0, 0, 0, 0);
      color: #fff;
      height: 20px;
      position: relative;
      top: 10px;
    }

    .other-login {
      margin-top: 28px;
      > span {
        margin-left: 24px;
        margin-right: 42px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        color: #fff;
      }
      .other-login-item {
        margin-right: 28px;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        border: 1px solid #fff;
        .svg-icon {
          width: 30px;
          height: 30px;
        }
      }
    }

    &.wx-content {
      background-color: #fff;
      padding: 18px 0;
      .login-switch {
        position: absolute;
        top: 0;
        right: 0;
        box-shadow: 0px -1px 3px rgba(0, 0, 0, 0.16);
        width: 0;
        height: 0;
        border-bottom: 43px solid #efefef;
        border-right: 43px solid transparent;
        .account-login {
          position: absolute;
          top: 2px;
          left: 18px;
          width: 20px;
          height: 20px;
        }
      }
    }

    &.login-curr {
      z-index: 10;
      opacity: 1;
      transform: translateX(0) !important;
    }
    &.login-next {
      z-index: 1;
      opacity: 0;
      transform: translateX(50px) !important;
    }
  }
}

#wx_box {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
